import { NgModule } from '@angular/core';
import { PrenotazioniListComponent } from './prenotazioni-list/prenotazioni-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { PostazioniViewComponent } from './visual-plan/visual-plan.component';
import { UserListComponent } from './user-list/user-list.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimeSegmentComponent } from './time-segment/time-segment.component';
import { AcuCardComponent } from './acu-card/acu-card.component';
import { PrenotazioniListRecapComponent } from './prenotazioni-list-recap/prenotazioni-list-recap.component';
import { AcuImgComponent } from './acu-image.component';
import { AcuCovidComponent } from './acu-covid/acu-covid.component';
import { AcuNotifyComponent } from './acu-notify/acu-notify.component';
import { AcuAlertMenuComponent } from './acu-alert-notify/acu-alert-menu/acu-alert-menu.component';
import { AcuAlertNotifyComponent } from './acu-alert-notify/acu-alert-notify.component';
import { RichiediPresenzaComponent } from './richiedi-presenza/richiedi-presenza.component';
import { AcuDateAccessibilityComponent } from './acu-date-accessibility/acu-date-accessibility.component';
import { AcuSummaryComponent } from './acu-summary/acu-summary.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { ModalRichiestaPresenzaComponent } from './richiedi-presenza/modal-richiesta-presenza/modal-richiesta-presenza.component';
import { ModalPianificaCoworkingComponent } from './richiedi-presenza/modal-pianifica-coworking/modal-pianifica-coworking.component';
import { ModalInvitoSalaComponent } from './richiedi-presenza/modal-invito-sala/modal-invito-sala.component';
import { AcuDefaultSedeComponent } from './acu-default-sede/acu-default-sede.component';
import { AcuDownloadComponent } from './acu-download/acu-download.component';
import { FavoritesHomeComponent } from './favorites-home/favorites-home.component';
import { PlanimetriaViewComponent } from './office-map/office-map.component';
import { PresenceTodayComponent } from './presence-today/presence-today.component';
import { AccessibleBookingViewComponent } from './accessible-booking-view/accessible-booking-view.component';
import { AcuQaWidgetComponent } from './acu-qa-widget/acu-qa-widget.component';

import { AcuFeedbackComponent } from './acu-feedback/acu-feedback.component';
import { SedeNonAbilitataComponent } from './sede-non-abilitata/sede-non-abilitata.component';


@NgModule({
  declarations: [
    PrenotazioniListComponent,
    PostazioniViewComponent,
    UserDetailComponent,
    UserListComponent,
    TimeSegmentComponent,
    AcuCardComponent,
    PrenotazioniListRecapComponent,
    AcuImgComponent,
    AcuCovidComponent,
    AcuNotifyComponent,
    AcuAlertMenuComponent,
    AcuAlertNotifyComponent,
    RichiediPresenzaComponent,
    AcuDateAccessibilityComponent,
    AcuSummaryComponent,
    ConfirmModalComponent,
    ModalRichiestaPresenzaComponent,
    ModalPianificaCoworkingComponent,
    ModalInvitoSalaComponent,
    AcuDefaultSedeComponent,
    AcuDownloadComponent,
    FavoritesHomeComponent,
    PlanimetriaViewComponent,
    PresenceTodayComponent,
    AccessibleBookingViewComponent,
    AcuQaWidgetComponent,
    AcuFeedbackComponent,
    SedeNonAbilitataComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    PrenotazioniListComponent,
    PostazioniViewComponent,
    UserDetailComponent,
    UserListComponent,
    TimeSegmentComponent,
    AcuCardComponent,
    PrenotazioniListRecapComponent,
    AcuImgComponent,
    AcuCovidComponent,
    AcuNotifyComponent,
    AcuAlertMenuComponent,
    AcuAlertNotifyComponent,
    RichiediPresenzaComponent,
    AcuDateAccessibilityComponent,
    AcuSummaryComponent,
    ConfirmModalComponent,
    ModalRichiestaPresenzaComponent,
    ModalPianificaCoworkingComponent,
    ModalInvitoSalaComponent,
    AcuDefaultSedeComponent,
    AcuDownloadComponent,
    FavoritesHomeComponent,
    PlanimetriaViewComponent,
    PresenceTodayComponent,
    AccessibleBookingViewComponent,
    AcuQaWidgetComponent,
    AcuFeedbackComponent,
    SedeNonAbilitataComponent
  ]
})
export class ComponentsModule {
}